// ======================================================
// ✅ authService.js – Servicio de Autenticación
// Proyecto: Evalúa Salud IPS
// Autor: Breyner Javier Montalvo Peñarredonda
// ------------------------------------------------------
// Centraliza todas las llamadas HTTP relacionadas con
// autenticación: login, registro, perfil, renovación JWT.
// ======================================================

import api from "../api/axiosConfig";

/**
 * 🔐 Iniciar sesión
 * @param {string} email - Correo electrónico del usuario
 * @param {string} password - Contraseña del usuario
 * @returns {Promise<object>} Respuesta del servidor
 */
export const iniciarSesion = async (email, password) => {
  const { data } = await api.post("/auth/login", { email, password });
  return data;
};

/**
 * 🧾 Registrar usuario
 * @param {object} datos - { nombre, email, password, rol }
 * @returns {Promise<object>}
 */
export const registrarUsuario = async (datos) => {
  const { data } = await api.post("/auth/register", datos);
  return data;
};

/**
 * 👤 Obtener perfil actual (requiere token JWT)
 * @returns {Promise<object>}
 */
export const obtenerPerfil = async () => {
  const { data } = await api.get("/auth/me");
  return data;
};

/**
 * ♻ Renovar token JWT
 * @returns {Promise<object>}
 */
export const renovarToken = async () => {
  const { data } = await api.get("/auth/renew");
  return data;
};
